<template>
  <div class="app-select" :class="[elClass]">
    <select
      :name="name"
      :id="id"
      :required="required"
      :disabled="disabled"
      @input="onInput($event)"
      @change="onChange($event)"
      @focus="onFocus($event)"
      @blur="onBlur($event)"     
    >
      <option hidden value="">{{ placeholder ? placeholder : '&nbsp;' }}</option>
      <option v-for="(option, index) of options" :key="index" :value="option.value" :selected="option.selected ? option.selected : false">{{option.name}}</option>
    </select>
    <div class="app-select-trigger"></div>
  </div>
</template>
<script>
export default {
  name: "app-select",
  props: {
    name: String,
    id: String,
    elClass: Array,
    options: {
      option: {
        value: String,
        name: String,
        selected: Boolean
      }
    },
    placeholder: String,
    required: Boolean,
    disabled: Boolean
  },
  methods: {
    onInput(event) {
      let emitValue = {};
      emitValue[this.id] = event;
      this.$emit("input", event);
    },
    onFocus(event) {
      let emitValue = {};
      emitValue[this.id] = event;
      this.$emit("focus", event);
    },
    onBlur(event) {
      let emitValue = {};
      emitValue[this.id] = event;
      this.$emit("blur", event);
    },
    onChange(event) {
      let emitValue = {};
      emitValue[this.id] = event;
      this.$emit("change", event);
    }
  }
};
</script>